<template>
  <div>
    <EmptyView v-if="isShowEmptyView" tabAll=tabAll :searchName=this.filter.searchName  style="margin-top: 150px;" v-on:reload-event="getMyListVacation(true)"/>
    <v-card id="cardTabMyList" outlined>
        <div v-if="isShowErrorView" v-on:click="getMyListVacation(true)" class="mx-auto" style="margin-top:100px; width:350px; height:400px;" >
          <ErrorView class="mx-auto" />
        </div>
        <div v-for="(vacationIds, date) in dividerDateTitles" :key="date">
        <DividerLine :groupTile="date" />
        <VacationItemRow v-for="vacationId in vacationIds" :key="vacationId" :vacationDate="date" :vacationInfo="getVacationById(vacationId)" />
       </div>   
       <div v-if="filter.showDateChoose && isShowAllList"
        class="" style="text-align: center; align-items: center; color: #1f97fe; font-size: 0.875rem; padding: 30px 0; cursor:pointer;">
       <button v-on:click="handleClick()">
         <span style="padding-right: 5px; ">{{ $t("show_all_month") }}</span>
         <img  src="@/assets/alllistarrow.png" alt="required" width="6" />
       </button>
      </div>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue';
import VacationItemRow from "@/components/commonui/topView/VacationItemRow";
import EmptyView from "../commonui/topView/EmptyView";
import ErrorView from "../commonui/topView/ErrorView";
import DividerLine from "../commonui/topView/DividerLine";
import { ListEvents, DefaultValues, TabNames, compareVacationDate, groupedDatesbyId} from "@/utilities/CommonUtilities";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import { VacationStatus, resizeMixin, ScreenNames, getUserRole, isApprover } from '../../utilities/CommonUtilities';

export default {
  mixins: [resizeMixin],
  props: {
    showErrorView: {
      type: Boolean,
    }
  },
  components: {VacationItemRow, EmptyView, ErrorView, DividerLine},
  data() {
    return {
      pageSize: DefaultValues.page_size,
      currentPageNumber: 1,
      pageInfo: {},
      listVacations:[],
      isShowEmptyView: false,
      isShowErrorView: this.showErrorView,
      isLoading: false,
      isDestroyed: false,
      todayVacationDividerID:null,
      nextVacationDividerID: null,
      keyIndex: 0,
      dividerDateTitles: {},
      tabAll: true,
      isShowAllList: false
    }
  },
  computed: {
    ...mapState(["userInfo", "token", "listUser", "timeSavedListUser"]),
    ...mapState({
      tabSelecting: (state) => state.homeData.currentTab,
      selectedTab: (state) => state.homeData.selectedTab,
      currentScreen: state => state.homeData.currentScreen,
    }),
    ...mapGetters({
      getTabInfo: "homeData/getTabInfo"
    }),
    ...mapGetters({
      filter: "homeData/getFilterInfo",
    }),
  },
  methods: {
    ...mapMutations({
        saveTabInfo: "homeData/setTabInfo",
        resetTabInfo: "homeData/resetTabInfo",
        saveFilter: "homeData/saveFilter",
    }),
    ...mapActions({
        resetAllTabInfo: "homeData/resetAllTabInfo"
    }),
    setTodayDividerLineID(vacations) {
      if(!this.todayVacationDividerID) {
          let va = vacations.find(vacation => compareVacationDate(vacation.from_date, vacation.to_date) == 0);
          if(va != null) { 
            this.todayVacationDividerID = va.id;
          }
      }
    },
    setNextDividerLineID(vacations) {
      if(!this.nextVacationDividerID) {
          let va = vacations.find(vacation => compareVacationDate(vacation.from_date, vacation.to_date) == 1);
          if(va != null) { 
            this.nextVacationDividerID = va.id;
          }
      }
    },
    getVacationById(id) {
      return this.listVacations.find((vacation) => vacation.id === id);
    },
    //Change date conditions.
    updateDividerDateTitles() {
      if (this.filter.fromDate && this.filter.lastDayOfMonth) {
        let startDate = new Date(this.filter.fromDate);
        let endDate = new Date(this.filter.lastDayOfMonth);
        if(this.filter.showDateChoose){
          startDate = new Date(this.filter.dateChoosed);
          endDate = new Date(this.filter.dateChoosed);
        }
        this.dividerDateTitles = groupedDatesbyId(this.listVacations, startDate, endDate, this.listUser);
        if (Object.keys(this.dividerDateTitles).length === 0) {
        this.isShowEmptyView = true;
        } else {
        this.isShowEmptyView = false;
        }
      }
    },
    isShowIconInProgress() {
      let userRole = getUserRole(this.userInfo.serviceInformation);
      return isApprover(userRole);
    },
    handleClick() {
      this.$nextTick(() => {
        var filterInfoTemp = {};
        filterInfoTemp.showDateChoose = false;
        filterInfoTemp.searchName = "";
        const currentMonthYear = new Date().toISOString().substring(0, 7);
        let yearMonth = this.filter.dateChoosed.substring(0, 7)
        filterInfoTemp.dateChoosed = yearMonth;
        if(this.filter.color != undefined) filterInfoTemp.color = this.filter.color;
        filterInfoTemp.toDate = this.filter.lastDayOfMonth;
        if(currentMonthYear === yearMonth){
          filterInfoTemp.fromDate = new Date().toISOString().substring(0, 10);
        } else {
          filterInfoTemp.fromDate = this.filter.firstDayOfMonth;
        }
        filterInfoTemp.firstDayOfMonth = this.filter.firstDayOfMonth;
        filterInfoTemp.lastDayOfMonth = this.filter.lastDayOfMonth;
        this.saveFilter(filterInfoTemp);
        this.notifyBus.$emit(ListEvents.vacationList);
      });
  },
  
    async getMyListVacation(isShowIndicator) {
      this.nextVacationDividerID = null;
      this.todayVacationDividerID = null;
      if(this.isLoading || this.listUser == null || this.listUser.length == 0) {
        return;
      }

      this.isLoading = true;
      isShowIndicator = true;
      if(isShowIndicator) this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      try {
        var params = {
          'token': this.token, 
          'limit': DefaultValues.page_size,
          'offset': (this.currentPageNumber - 1) * DefaultValues.page_size,
          'order_from':'asc'
        };
        if (this.filter != null) {
          params["from_date"] = `${this.filter.firstDayOfMonth} 00:00:00`;
          params["to_date"] = `${this.filter.lastDayOfMonth} 23:59:59`;
          params["order_from"] = "desc";
        }

        let response = await this.dataSource.getData(this.dataSource.listVacations, params);
        let vacationsInPage = response.data['vacations'];
        let totalPage = response.data['totalPage'];

        this.pageInfo.pageItems = vacationsInPage;
        this.pageInfo.totalPage = totalPage;
        this.pageInfo.currentPage = this.currentPageNumber;
          
        this.setNextDividerLineID(vacationsInPage);
        this.setTodayDividerLineID(vacationsInPage);
        this.isShowAllList  = true;
        if (!this.isShowIconInProgress()) {
          this.listCalendars = vacationsInPage.filter(vacation =>
          (vacation.status === VacationStatus.Approved) || 
          (vacation.status === VacationStatus.InProgress && vacation.user_id === this.userInfo.userID)
        );
        } else {
          this.listCalendars = vacationsInPage
        }
        if (this.filter.searchName != null && this.filter.searchName != "" ){
          let searchName = this.filter.searchName.trim();
          this.listVacations = vacationsInPage.filter(vacation => vacation.status === VacationStatus.Approved && vacation.name.match(new RegExp(searchName, 'i'))); 
        } else {  
            this.listVacations = vacationsInPage.filter(item => item.status === VacationStatus.Approved);
        }
        // sort by created_at
        this.listVacations.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

        this.keyIndex += 1;
        if(this.listVacations.length == 0) {
          this.isShowEmptyView = true;
        } else {
          this.isShowEmptyView = false;
        }

        let thisInfo = {};
        Object.assign(thisInfo, this.pageInfo);
        this.saveTabInfo({ tabInfo: thisInfo, tabName: TabNames.All});

        if(this.isDestroyed) return;
        this.notifyBus.$emit(ListEvents.setStatusMonth, this.listCalendars)
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.currentPageNumber, totalPage: totalPage});

        //hide error view
        this.isShowErrorView = false;
      } catch(ex) {

        //error at the first time
        if(this.pageInfo.totalPage == null) {
          this.isShowEmptyView = false;
          this.isShowErrorView = true;
          if(this.isMobile && this.currentScreen === ScreenNames.Calendar){
            this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
          }

          return;
        }

        this.currentPageNumber = this.pageInfo.currentPage;
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
        if(isShowIndicator) {
           this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
        }
        return;
      } finally {
        if(isShowIndicator) this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
        this.isLoading = false;
      }
    },
    loadTabInfo() {
      this.pageInfo = this.getTabInfo(TabNames.All);
      this.currentPageNumber = this.pageInfo.currentPage;
      if(this.pageInfo.totalPage != null) {
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
      }
    },
    refreshDataFromDatePicker() {
      if (this.tabSelecting === TabNames.All && this.selectedTab === TabNames.All) this.getMyListVacation(true);
    },
  },
  watch: {
    listVacations: {
      handler() {
        this.updateDividerDateTitles();
      },
      deep: true,
    },
  },
  mounted() {
    this.notifyBus.$on(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  async created() {
    if(this.pageInfo.pageItems != null) {
      this.listVacations = [];
      this.listVacations = this.pageInfo.pageItems;
    }
    if (this.homeViewBus instanceof Vue) {
      this.homeViewBus.$on(ListEvents.loadDataCompleted, (tabName) => {
        if(tabName == null) {
          this.getMyListVacation(true);
        }
      });
    }

    this.notifyBus.$on(ListEvents.paginationChanged, (newCurrentPage) => {
      if(this.isLoading || newCurrentPage == this.currentPageNumber || this.isDestroyed) return;

      this.currentPageNumber = newCurrentPage;
      this.getMyListVacation(true);
    });

    this.notifyBus.$on(ListEvents.reloadAllTabs,(reloadAll) => {
      if(this.isDestroyed) return;

      if(reloadAll) {
        this.resetAllTabInfo();
        this.loadTabInfo();
      }
      this.getMyListVacation(true);
    });

    this.notifyBus.$on(ListEvents.reloadByFilter, () => {
      if(this.isDestroyed) return;

      this.nextVacationDividerID = null;
      this.todayVacationDividerID = null;

      this.resetTabInfo(TabNames.All);
      this.loadTabInfo();
      
      this.getMyListVacation(true);
    });
    this.getMyListVacation(this.pageInfo.totalPage == null || this.pageInfo.totalPage == undefined);
  },
  beforeDestroy: function() {
    this.isDestroyed = true;
    this.notifyBus.$off(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  inject: ["dataSource", "notifyBus", "homeViewBus"],
};
</script>

<style scoped>
#cardTabMyList{
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius:0px;
}
</style>